import { type GenericMap } from "@common/declarations";
import { groupBy, sortBy } from "lodash";
import moment from "moment";
import { type TimelineItemInfo } from "./component";

export const getHtmlId = (id: string | undefined): string | undefined => (id ? `tli_${id}` : undefined);

export const groupByDate = (items: TimelineItemInfo[]): GenericMap<TimelineItemInfo[]> => {
  const groups = groupBy(items, (x) => moment(x.date).format("DD MMMM YYYY")) as GenericMap<TimelineItemInfo[]>;

  Object.keys(groups).forEach((key) => {
    groups[key] = sortBy(groups[key], "createdOnDate");
  });

  return groups;
};
